import { Component, Input, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';


import { detailsSegmentData } from '../../../segment-data/details-segment-data';
import { validations } from 'shared/validation/validations';
import { SegmentFieldItem } from 'utils/segment-field-item.interface';

import { BaseScorecardComponent } from '../base/_base-scorecard.component';
import { ScorecardItemComponent } from 'shared/scorecard/scorecard-item/scorecard-item.component';

import { ScorecardConnectorService } from 'shared/scorecard/scorecard-connector.service';


@Component({
  moduleId: module.id,
  selector: 'details-scorecard',
  templateUrl: 'details-scorecard.component.html',
  styleUrls: ['details-scorecard.component.scss'],
})
export class DetailsScorecardComponent extends BaseScorecardComponent {
  segmentTitle: string = 'Details';
  segmentData: any = detailsSegmentData;

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get segmentScores(): any {
    return _.get(this.scoreData, 'segments.details.tallies');
  }

  constructor(
    protected ref: ChangeDetectorRef,
    protected scorecardConnectorService: ScorecardConnectorService,
  ) {
    super(ref, scorecardConnectorService);
  }

  /*******************************************
  * COMPONENT PROTECTED METHODS
  *******************************************/

  protected handleControlFocus(data: any): void {
    const scorecardItem = this.findScorecardItem('fieldMap', data.item.field_map);
    this.collapseExpandedScores(data.item.field_map);
    if (_.get(scorecardItem, 'collapsed')) {
      if (this.scorecard) {
        this.scorecard.scrollToScorecardItem(scorecardItem);
      }
      _.defer(() => {
        scorecardItem.collapseDetails(false);
        this.ref.markForCheck();
      });
    }
  }

  /*
    * $event: {populated: 1|0, item: SegmentFieldItem}
   */
  protected getItemFieldScoreFromEvent($event: any) {
    return _.get(this.segmentScores, $event.item.item_name);
  }


  /*******************************************
  * COMPONENT PRIVATE METHODS
  *******************************************/

  private getItemValidationMessage(item: SegmentFieldItem): string {
    const score: any = _.get(this.segmentScores, item.item_name);
    return this.getValidationMessage(item, score);
  }
}
